var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" 입찰 디폴트 레이아웃"),_c('br'),_c('button',{on:{"click":function($event){return _vm.openModal('auction-history-modal')}}},[_vm._v("경매 내역")]),_c('br'),_c('button',{on:{"click":function($event){return _vm.movePage('/openmarket/bid')}}},[_vm._v("입찰(페이지)")]),_c('auction-history-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }